import { Button } from '@honeyscience/honey-ui-toolkit';
import React, { ReactElement } from 'react';
import { createUseStyles } from 'react-jss';
import { useHistory } from 'react-router-dom';
import Header from 'mockStores/components/stores/Header';

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '40px',
  },
});

function Continue(): ReactElement {
  const classes = useStyles();
  const history = useHistory();

  const returnToStore = () => history.goBack();

  return (
    <div className={ classes.container }>
      <Header
        title="Honey Checkout Mock Store Continue Page"
        description="Continue Page - typically the 'agree to pay' page."
      />
      <Button
        id="returnToStoreButton"
        buttonType="secondary"
        onClick={ returnToStore }
        isFlexible
        copy="Return to Store"
        size={ 48 }
      />
    </div>
  );
}

export default Continue;
